// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"ebc2e9ad","513":"3194fedf"}[chunkId] + ".chunk.js";
};